<app-users-listing [enableMainBtn]="true" [titleMainBtn]="'Aggiungi Tutore'" [type]="type"
  [linkMainBtn]="'/nuovo-utente'" [linkMainBtnQueryParams]="{type: type}">
</app-users-listing>